/*
 * Copyright (c) 2019 Pegasystems Inc.
 * All rights reserved.
 */
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { resolveRestApi } from '../../router/app-router';
import { fetch } from '../../service_broker/fetch';
import { getSubmitData } from '../../store/state/epics/util';
import { logAndCatchError } from '../../utils/rxjs-utils';
import { appendJSActionQueryParams } from '../../utils/case-utils';

import type { ActionPayload } from './types';

const DXAPI_ERROR = 'Error occurred during ajax call at getDataObjectView Epic';

const executeSubmitDataObjectFlowAction = (actionInPayload: ActionPayload) => {
  const { savableDatapage, context, headers, actionID, keys, containerItemID, jsActionQueryParams } = actionInPayload;

  const requestParams = {
    data_view_ID: savableDatapage,
    action_ID: actionID
  };
  let { restApi } = resolveRestApi('submitDataObjectAction', requestParams);
  const { reqType } = resolveRestApi('submitDataObjectAction', requestParams);
  const { content: requestPayload } = getSubmitData(containerItemID);

  restApi = appendJSActionQueryParams(jsActionQueryParams, restApi);

  return from(
    fetch(
      restApi,
      {
        method: reqType,
        headers: {
          ...headers,
          'if-match': actionInPayload?.etag
        },
        body: {
          data: {
            ...requestPayload?.content,
            ...keys
          },
          pageInstructions: requestPayload?.pageInstructions || []
        }
      },
      context
    )
  ).pipe(
    map((response: any) => {
      return {
        response: response.data,
        actionInPayload
      };
    }),
    logAndCatchError(DXAPI_ERROR, context)
  );
};

export default executeSubmitDataObjectFlowAction;
